<template>
<div class="control-panel">
  <login @rememberPassword="rememberPassword"></login>
  <app-menu v-if="isAuthenticated"></app-menu>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as authTypes from '@/store/actions/auth'
import Login from '@/components/login'
import AppMenu from '@/components/appMenu'
import * as controlPanelTypes from '@/store/actions/controlPanel'

export default {
  name: 'control-panel',
  components: {
    Login,
    AppMenu
  },
  methods: {
    rememberPassword (rememberPassword) {
      this.$emit('rememberPassword', rememberPassword)
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    open () {
      return this.$store.getters[`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}/${controlPanelTypes.CONTROL_PANEL_IS_OPEN}`]
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/controlPanel/index.vue